// src/features/landing/infrastructure/jobSeekerRequestApiRepository.js

const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

async function createJobSeekerRequest(data, accessToken) {
    const headers = { 'Content-Type': 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
    const response = await fetch(`${API_BASE_URL}/api/job-seeker-requests`, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || '신청에 실패했습니다.');
    }

    return response.json();
}

/**
 * 파일을 백엔드를 통해 S3에 직접 업로드
 * @param {File} file
 * @param {'RESUME'|'ETC'} fileType
 * @returns {Promise<{fileKey: string}>}
 */
async function uploadFile(file, fileType = 'RESUME') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileType', fileType);

    const response = await fetch(`${API_BASE_URL}/api/job-seeker-requests/files/upload`, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || '파일 업로드에 실패했습니다.');
    }

    return response.json();
}

async function getById(id) {
    const response = await fetch(`${API_BASE_URL}/api/job-seeker-requests/${id}`);
    if (!response.ok) throw new Error('상세 정보를 불러오는데 실패했습니다.');
    return response.json();
}

async function getList({ status, jobCategoryCode, page = 0, size = 50 } = {}) {
    const url = new URL(`${API_BASE_URL}/api/job-seeker-requests`);
    if (status) url.searchParams.set('status', status);
    if (jobCategoryCode) url.searchParams.set('jobCategoryCode', jobCategoryCode);
    url.searchParams.set('page', page);
    url.searchParams.set('size', size);

    const response = await fetch(url.toString());
    if (!response.ok) throw new Error('목록 조회에 실패했습니다.');
    return response.json();
}

async function getMyPosts(accessToken) {
    const response = await fetch(`${API_BASE_URL}/api/job-seeker-requests/my`, {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const error = new Error(err.message || '내 구직글 조회에 실패했습니다.');
        error.status = response.status;
        throw error;
    }
    return response.json();
}

async function setActive(id, active, accessToken) {
    const response = await fetch(`${API_BASE_URL}/api/job-seeker-requests/${id}/active`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify({ active }),
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const error = new Error(err.message || '상태 변경에 실패했습니다.');
        error.status = response.status;
        throw error;
    }
}

async function update(id, data, accessToken) {
    const response = await fetch(`${API_BASE_URL}/api/job-seeker-requests/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const error = new Error(err.message || '수정에 실패했습니다.');
        error.status = response.status;
        throw error;
    }
    return response.json();
}

async function deleteById(id, accessToken) {
    const response = await fetch(`${API_BASE_URL}/api/job-seeker-requests/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const error = new Error(err.message || '삭제에 실패했습니다.');
        error.status = response.status;
        throw error;
    }
}

async function getDownloadUrl(fileKey) {
    const response = await fetch(`${API_BASE_URL}/api/job-seeker-requests/files/download-url?fileKey=${encodeURIComponent(fileKey)}`);
    if (!response.ok) throw new Error('다운로드 URL 발급에 실패했습니다.');
    return response.text();
}

export const jobSeekerRequestRepository = {
    createJobSeekerRequest,
    uploadFile,
    getList,
    getById,
    getMyPosts,
    setActive,
    update,
    deleteById,
    getDownloadUrl,
};
